import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../utils/Loader';
import { setStatFilters, getHistoryInvoice } from '../../action/statistics';
import { fetchCities, fetchFilials } from '../../action/handbook';
import DateInput from '../utils/DateInput';
import moment from 'moment';
import { isEmpty } from 'lodash';
import Select from 'react-select';
import { categoriesRawByType, rawsByCategory, selectedRawsByType } from '../../selectors/raw';
import { fetchProductCategories, fetchRawsList } from '../../action/raw';
import ReactPaginate from 'react-paginate';
import {utils, writeFileXLSX} from "xlsx";
import PointsSelect from '../utils/PointsSelect';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import RawsSelect from '../utils/RawsSelect'
import swal from 'sweetalert';
import { fetchSuppliers } from '../../action';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
}

const getDateValue = (type) => {
    const date = new Date()
    switch(type){
        case 'tomorrow':{
            return {Min: moment(date).add(1,'days').format('YYYY-MM-DD 00:00:00'), Max: moment(date).add(1,'days').format('YYYY-MM-DD 23:59:59')};
        }
        case 'yesterday':{
            return {Min: moment(date).subtract(1,'days').format('YYYY-MM-DD 00:00:00'), Max: moment(date).subtract(1,'days').format('YYYY-MM-DD 23:59:59')};
        }
        case 'week':{
            let monday = moment(date);
            monday.startOf('isoWeek'); 

            let sunday = moment(date);
            sunday.endOf('isoWeek'); 

            return {Min: monday.format('YYYY-MM-DD 00:00:00'), Max: sunday.format('YYYY-MM-DD 23:59:59')};
        }
        case 'prevWeek':{
            let monday = moment(date).subtract(1, 'weeks').startOf('isoWeek');
            let sunday = moment(date).subtract(1, 'weeks').endOf('isoWeek');
            return {
                Min: monday.format('YYYY-MM-DD 00:00:00'),
                Max: sunday.format('YYYY-MM-DD 23:59:59')
            };            
        }
        case 'month':{
            return {Min: moment(date).startOf('month').format('YYYY-MM-DD 00:00:00'), Max: moment(date).endOf('month').format('YYYY-MM-DD 23:59:59')};
        }
        case 'prevMonth': {
            let start = moment(date).subtract(1, 'months').startOf('month');
            let end = moment(date).subtract(1, 'months').endOf('month');         
            return {
                Min: start.format('YYYY-MM-DD 00:00:00'),
                Max: end.format('YYYY-MM-DD 23:59:59')
            };            
        }
        default: {
            return {Min: moment(date).format('YYYY-MM-DD 00:00:00'), Max: moment(date).format('YYYY-MM-DD 23:59:59')};
        }
    }
}


class HistoryInvoice extends Component {
    state = {
        currentPage: 0,
        selectedDate: null,
        openDateInput: false,
        history: null,
        count: 0,
        dateValue: [
            {label: `Завтра ${moment(getDateValue('tomorrow').Min).format('DD.MM.YYYY')}`, value: getDateValue('tomorrow')},
            {label: `Сегодня ${moment(getDateValue('today').Min).format('DD.MM.YYYY')}`, value: getDateValue('today')},
            {label: `Вчера ${moment(getDateValue('yesterday').Min).format('DD.MM.YYYY')}`, value: getDateValue('yesterday')},
            {label: 'Текущая неделя', value: getDateValue('week')},
            {label: 'Прошлая неделя', value: getDateValue('prevWeek')},
            {label: 'Текущий месяц', value: getDateValue('month')},
            {label: 'Прошлый месяц', value: getDateValue('prevMonth')},
            {label: 'Период', value: 'period'}
        ],
    }

    DateInputRef = React.createRef();

    onChangeDateSelect = (e) => {
        const { filters } = this.props.historyInvoice;

        const updated = { ...filters };

        if(e.value !== 'period') {
            updated.createdStartDate = moment(e.value.Min).toDate();
            updated.createdEndDate = moment(e.value.Max).toDate();        
            this.props.setStatFilters('historyInvoice', { ...updated, start: 0 });
            this.setState({ 
                selectedDate: e,
                currentPage: 0
            });
            this.onSearch({ ...updated, start: 0, limit: filters.limit });
        } else {
            this.setState({ openDateInput: true });
        }
    }

    onSearch = async (filters) => {
        const params = filters ? filters : this.props.historyInvoice.filters;
        const data = await this.props.getHistoryInvoice(params);
        this.setState({ history: data.result, count: data.count });
    }

    componentDidMount() {
        this.onChangeDateSelect(this.state.dateValue[1]);
        if (isEmpty(this.props.cities)) this.props.fetchCities();
        if (isEmpty(this.props.filials)) this.props.fetchFilials();
        if (isEmpty(this.props.categories)) this.props.fetchProductCategories();
        if (isEmpty(this.props.rawsList)) this.props.fetchRawsList();
        if (isEmpty(this.props.suppliers)) this.props.fetchSuppliers();
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props.historyInvoice;
        const updated = { ...filters, [field]: date };
        if (field === 'createdStartDate') updated.createdEndDate = moment(date).add({ days: 30 }).toDate()
        this.props.setStatFilters('historyInvoice', { ...updated, start: 0 });
    }

    setData = (field) => (data) => {
        const { filters } = this.props.historyInvoice;
        const updated = { ...filters };
        let value = null;
        if (data) {
            if (data.value) {
                value = data.value;
            } else {
                value = data;
            }
        }
        updated[field] = value;
        this.props.setStatFilters('historyInvoice', { ...updated, start: 0 });
        this.setState({ currentPage: 0 }, () => {
            this.onSearch({ ...updated, start: 0, limit: filters.limit });
        });
    }

    setRawData = (field) => (data) => {
        const { filters } = this.props.historyInvoice;
        const updated = { ...filters };
        let value = null;
        if (data) {
            if (Array.isArray(data)) {
                if (data.length > 0 && typeof data[0] === 'object' && data[0].value !== undefined) {
                    value = data.map(item => item.value);
                } else {
                    value = data;
                }
            }
            else if (typeof data === 'object' && data.id !== undefined) {
                value = [data.id];
            }
            else {
                value = Array.isArray(data) ? data : [data];
            }
        }      
        updated[field] = value;
        this.props.setStatFilters('historyInvoice', { ...updated, start: 0 });
        this.setState({ currentPage: 0 }, () => {
            this.onSearch({ ...updated, start: 0, limit: filters.limit });
        });
    }

    renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    onExport = async () => {
        const { filters } = this.props.historyInvoice;
        const params = { ...filters };
        delete params.start;
        delete params.limit;
        params.noPagination = true;
        if (params.points.length !== 1){
            return (
                swal({
                    title: "Экспорт возможен только для одного филиала",
                    text: "Выберите один и повторите попытку",
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                })
            ) 
        }
       
        const data = await this.props.getHistoryInvoice(params);
        const exportData = data.result.flatMap((invoice) => {
            const point = this.props.filials.find((item) => item.id === invoice.point.id);
            if (!invoice.rawMaterials || invoice.rawMaterials.length === 0) return;
            return invoice.rawMaterials.map((raw) => {
                if (filters.raws && filters.raws.length > 0 && (!raw || !raw.id || !filters.raws.includes(raw.id))) return null;
                return {
                    'Наименование': raw.name,
                    'Филиал': this.renderPointLabel(point),
                    'Номер накладной': invoice.number,
                    'Дата': moment(invoice.date).format('DD.MM.YYYY HH:mm'),
                    'Поставщик': invoice.supplier.name,
                    'Количество': parseNumToFixed(raw.quantity, 3),
                    'Цена': parseNumToFixed(raw.price),
                    'Сумма': parseNumToFixed(raw.totalPrice),
                }
            });
        });
        const ws = utils.json_to_sheet(exportData.filter(item => item !== null));
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "История закупок");
        writeFileXLSX(wb, `История закупок с ${moment(filters.createdStartDate).format('DD-MM-YYYY')} по ${moment(filters.createdEndDate).format('DD-MM-YYYY')}.xlsx`);
    }

    renderHead() {
        const { filters } = this.props.historyInvoice;
        
        const supplierOptions = this.props.suppliers.map(supplier => ({
            value: supplier.id,
            label: supplier.name,
        }));

        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        История закупок
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ alignItems: 'start', gap: '10px' }}>
                    <div style={{ width: 250 }}>
                        <Select
                            isLoading={this.props.loadingFilials}
                            isDisabled={ this.props.loadingFilials}
                            placeholder='Дата'
                            value={this.state.selectedDate}
                            onChange={(e) => this.onChangeDateSelect(e)}
                            options={this.state.dateValue}
                        />
                        {this.state.openDateInput && <div style={{ position: 'relative' }}>
                            <div ref={this.DateInputRef} style={{ position: 'absolute', zIndex: '1', backgroundColor: '#fff', borderRadius: '4px', padding: '10px', color: '#000', marginTop: '10px' }}>
                                <div>Период с</div>
                                <DateInput                                            
                                    placeholderText="Дата от"
                                    selected={filters.createdStartDate}
                                    onChange={this.onChangeDateInput('createdStartDate')}
                                />
                                <div>по</div>
                                <DateInput
                                    placeholderText="Дата до"
                                    selected={filters.createdEndDate}
                                    onChange={this.onChangeDateInput('createdEndDate')}
                                    maxDate={moment(filters.createdStartDate).add({ years: 1 }).toDate()}
                                    required={filters.createdStartDate}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px'}}>
                                    <button
                                    className='btn btn-secondary'
                                    onClick={(() => {
                                        this.setState({ openDateInput: false });
                                    })}
                                    >
                                        Закрыть
                                    </button>
                                    <button 
                                    className='btn btn-primary'
                                    onClick={(() => {
                                    const dateValue = [...[...this.state.dateValue].filter((item) => item.value !== 'period'), {label: `Период ${moment(filters.createdStartDate).format('DD.MM.YYYY HH:mm')} - ${moment(filters.createdEndDate).format('DD.MM.YYYY HH:mm')}`, value: 'period'}];
                                    this.setState({ 
                                        selectedDate: dateValue[dateValue.length - 1],
                                        openDateInput: false,
                                        dateValue: dateValue,
                                    });
                                    this.onSearch();
                                    })}
                                    >
                                        Найти
                                    </button>
                                </div>
                            </div>
                        </div>}
                    </div> 
                    <PointsSelect width={200} placeholder='Все филиалы' values={filters.points} setData={this.setData('points')}/>
                    <div style={{ width: 175 }}>
                        <Select
                            options={supplierOptions}
                            placeholder="Поставщик"
                            isClearable={true}
                            onChange={this.setData('supplier')}
                            isLoading={this.props.suppliersLoading}
                        />
                    </div>
                    <div style={{ width: 200}}><RawsSelect groupedRaws={this.props.groupedRaws} width={200} placeholder='Сырье' values={filters.raws} onChange={this.setRawData('raws')}/></div>                
                    {this.state.history && this.state.history.length > 0 && <button onClick={this.onExport} className='btn btn-success'>
                        Экспорт
                    </button>}
                </div>
            </div>
        );
    }

    handlePageClick = (data) => {
        const { filters } = this.props.historyInvoice;
        this.setState({ currentPage: data.selected });
        let nextStart = data.selected * filters.limit;
        const updated = { ...filters, start: nextStart, };
        this.props.setStatFilters('historyInvoice', updated);
        this.onSearch(updated);
    };


    setPageLimit = (e) => {
        e.preventDefault();
        const { filters } = this.props.historyInvoice;
        let limit = parseInt(e.target.value, 10);
        if (Number.isNaN(limit) || limit <= 0) {
            limit = 10;
        }
        const updated = { ...filters, start: 0, limit };
        this.setState({ currentPage: 0 });
        this.props.setStatFilters('historyInvoice', updated);
        this.onSearch(updated);
    }

    chekMarginPagesDisplayed() {
        const userDisplayWidth = window.innerWidth;
        if (userDisplayWidth < 400) return 1;
        if (userDisplayWidth < 550) return 2;
        if (userDisplayWidth < 850) return 3;
        if (userDisplayWidth < 1250) return 5;
        return 8;
    }

    chekPageRangeDisplayed() {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    renderPagination() {
        const { filters } = this.props.historyInvoice;
        const pages = Math.ceil(+this.state.count / +filters.limit);
        if (!this.state.history || this.state.history.length === 0) return;

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={this.chekMarginPagesDisplayed()}
                    pageRangeDisplayed={this.chekPageRangeDisplayed()}
                    forcePage={this.state.currentPage}
                    onPageChange={this.handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={this.setPageLimit} value={filters.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                            </select>
                            
                        </div>
                        {
                            filters.start + filters.limit >= this.state.count ? (
                                <span className="kt-datatable__pager-detail">Показано накладных {filters.start + 1} - {+this.state.count} из {this.state.count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано накладных {filters.start + 1} - {+filters.start + +filters.limit} из {this.state.count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    renderBody() {
        const { loading, filters } = this.props.historyInvoice;
        const { history } = this.state;

        if (loading) return <div style={styles.loading}><Loader /></div>;
        
        return(
            <>
            <div className="kt-portlet">
                <div className='kt-portlet__body'>
                    <div className='kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid' style={{ padding: '0px' }}>
                        <div className='kt-portlet kt-portlet--mobile'>
                            <div className='kt-portlet__body kt-portlet__body--fit'> 
                                <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                                    <table className='kt-datatable__table'>
                                        {history && history.length > 0 && <thead className='kt-datatable__head'>
                                            <tr className='kt-datatable__row'>
                                                <th className='kt-datatable__cell' style={{ width: 'auto' }}><span>Наименование</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Дата</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Поставщик</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Количество</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Цена</span></th>
                                                <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Сумма</span></th>
                                            </tr>
                                        </thead>}
                                        <tbody className='kt-datatable__body'>
                                            {(!history || history.length === 0)
                                            ? <tr className='kt-datatable__row'>Нет данных</tr> 
                                            : history.map((invoice) => {
                                                if (!invoice.rawMaterials || invoice.rawMaterials.length === 0) return null;
                                                const point = this.props.filials.find((item) => item.id === invoice.point.id);
                                                return (
                                                    <>
                                                        <tr className='kt-datatable__row' style={{ fontWeight: '600' }}>
                                                            <td className='kt-datatable__cell' style={{width: '250px'}} ><span> Накладная №{invoice.number} </span></td>                                                            
                                                            <td className='kt-datatable__cell' style={{width: 'auto', textAlign:'left'}}><span> Филиал: {this.renderPointLabel(point)} </span></td>
                                                        </tr>
                                                        {invoice.rawMaterials.sort((a, b) => a.name.localeCompare(b.name)).map((raw) => {                                                            
                                                            if (filters.category && (!raw || !raw.productscategory || raw.productscategory !== filters.category)) return null;
                                                            if (filters.raws && filters.raws.length > 0 && (!raw || !raw.id || !filters.raws.includes(raw.id))) return null;
                                                            return (
                                                            <tr className='kt-datatable__row'>
                                                                <td className='kt-datatable__cell' style={{ width: 'auto' }}><span>{raw.name}</span></td>
                                                                <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{moment(invoice.date).format('DD.MM.YYYY HH:mm')}</span></td>
                                                                <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{invoice.supplier.name}</span></td>
                                                                <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{parseNumToFixed(raw.quantity, 3) || 0}</span></td>
                                                                <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{formatNumberWithSpaces(parseNumToFixed(raw.price)) || 0}</span></td>
                                                                <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{formatNumberWithSpaces(parseNumToFixed(raw.totalPrice)) || 0}</span></td>
                                                            </tr>
                                                            )})
                                                        }
                                                    </>                                                        
                                                )})
                                            }
                                        </tbody>
                                    </table>
                                    {this.renderPagination()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }

    render() {
        return (
            <>
                <div className="kt-portlet">
                    {this.renderHead()}
                </div>
                {this.renderBody()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return ({
        categories: categoriesRawByType('raw')(state),
        rawsList: selectedRawsByType('raw')(state), 
        groupedRaws: rawsByCategory(state),
        historyInvoice: state.statistics.historyInvoice,
        loadingFilials: state.loaders.filials,
        suppliersLoading: state.loaders.suppliers,
        filials: state.handbook.filials,
        suppliers: state.suppliers.items,
    });
};

const mapDispatchToProps = {
    fetchProductCategories: () => fetchProductCategories('raw'),
    fetchCities: () => fetchCities(true),
    fetchRawsList: () => fetchRawsList(true),
    fetchFilials: () => fetchFilials(null, true),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    getHistoryInvoice: (filters) => getHistoryInvoice(filters),
    fetchSuppliers: () => fetchSuppliers(false, true),
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoryInvoice);